import React, { ChangeEvent, useEffect, useState } from 'react';
import { Breadcrumbs, Input } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS } from 'utils/constants';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar-icon.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/time-icon.svg';
import './styles.scss';
import useCreateDealContext from 'contexts/create-deal.context';
import DatePicker from 'components/base/date-picker';
import moment from 'moment';
import TimeSelector from 'components/base/time-selector';

const CreateDealTimeline = () => {
  const { createDealForm, setCreateDealForm, setDisabled, images } = useCreateDealContext();
  const [noExpirationDate, setNoExpirationDate] = useState(!createDealForm.to_expire_date);
  const [showStartDateModal, setShowStartDateModal] = useState(false);
  const [showEndDateModal, setShowEndDateModal] = useState(false);
  const breadcrumbs = [
    { name: 'Deals & Discount', path: ROUTE_KEYS.DEALS_AND_DISCOUNTS },
    { name: 'New Deal & Discount', path: '' }
  ];

  useEffect(() => {
    if (
      !createDealForm.heading ||
      !createDealForm.title ||
      !createDealForm.body ||
      !images.length ||
      !createDealForm.cokitchen_ids.length ||
      !createDealForm.discount_code ||
      !createDealForm.deal_value_type_id ||
      !createDealForm.cap ||
      !createDealForm.max_usage ||
      !createDealForm.deal_type_id ||
      !createDealForm.deal_requirement_type_id ||
      !createDealForm.deal_eligibility_type_id ||
      !createDealForm.to_start_date ||
      (!noExpirationDate && !createDealForm.to_expire_date)
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [createDealForm]);

  const handleNoExpiryDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setCreateDealForm({
        ...createDealForm,
        to_expire_date: undefined,
        to_expire_time: null
      });
    }
    setNoExpirationDate(e.target.checked);
  };
  return (
    <div className='mx-10 pt-8 max-w-[700px]'>
      {showStartDateModal && (
        <DatePicker
          isOpen={showStartDateModal}
          onClose={() => setShowStartDateModal(false)}
          title='Select Start Date'
          handleDateSelect={(value) =>
            setCreateDealForm({
              ...createDealForm,
              to_start_date: value,
              to_expire_date: undefined,
              to_expire_time: null
            })
          }
          minDate={new Date()}
        />
      )}
      {showEndDateModal && (
        <DatePicker
          isOpen={showEndDateModal}
          onClose={() => setShowEndDateModal(false)}
          title='Select Expiry Date'
          handleDateSelect={(value) =>
            setCreateDealForm({ ...createDealForm, to_expire_date: value })
          }
          minDate={createDealForm.to_start_date || new Date()}
        />
      )}
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className='mt-8'>
        <PageHeaderText
          title='Create Deal & Discount'
          description='Create a new deal lorem dolum ipsum'
        />
      </div>
      <div className='flex items-start w-full gap-4 mb-6'>
        <section className='flex flex-col gap-1.5 grow'>
          <p className='text-gray-6 text-sm'>Start date</p>
          <div
            className='border border-gray-19 rounded-md flex items-center  py-4 px-5 cursor-pointer h-[50px]'
            onClick={() => setShowStartDateModal(true)}>
            <CalendarIcon className='mr-2' />
            <p className='text-sm text-gray-6'>
              {createDealForm.to_start_date
                ? moment(createDealForm.to_start_date).format('YYYY-MM-DD')
                : 'YYYY-MM-DD'}
            </p>
          </div>
        </section>
        <section className='flex flex-col gap-1.5 grow'>
          <p className='text-gray-6 text-sm'>Start time</p>
          <div className='border border-gray-19 rounded-md flex items-center py-4 px-5 h-[50px]'>
            <TimeIcon className='mr-2' />
            <TimeSelector
              value={createDealForm.to_start_time}
              onChange={(value) => setCreateDealForm({ ...createDealForm, to_start_time: value })}
            />
          </div>
        </section>
      </div>
      {!noExpirationDate && (
        <div className='flex items-start w-full gap-4'>
          <section className='flex flex-col gap-1.5 grow'>
            <p className='text-gray-6 text-sm'>Expiry date</p>
            <div
              className='border border-gray-19 rounded-md flex items-center  py-4 px-5 cursor-pointer h-[50px]'
              onClick={() => setShowEndDateModal(true)}>
              <CalendarIcon className='mr-2' />
              <p className='text-sm text-gray-6'>
                {createDealForm.to_expire_date
                  ? moment(createDealForm.to_expire_date).format('YYYY-MM-DD')
                  : 'YYYY-MM-DD'}
              </p>
            </div>
          </section>
          <section className='flex flex-col gap-1.5 grow'>
            <p className='text-gray-6 text-sm'>Stop time</p>
            <div className='border border-gray-19 rounded-md flex items-center py-4 px-5 h-[50px]'>
              <TimeIcon className='mr-2' />
              <TimeSelector
                value={createDealForm.to_expire_time}
                onChange={(value) =>
                  setCreateDealForm({ ...createDealForm, to_expire_time: value })
                }
              />
            </div>
          </section>
        </div>
      )}
      <div className='flex items-center gap-2 mt-6'>
        <Input
          type='checkbox'
          checked={noExpirationDate}
          onChange={(e) => {
            handleNoExpiryDateChange(e);
          }}
        />
        <p className='font-medium'>No expiration date</p>
      </div>
    </div>
  );
};

export default CreateDealTimeline;
